// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"a672c2b1","453":"9f8ed274","663":"cd1ee715"}[chunkId] + ".chunk.js";
};